import { GridValueFormatterParams } from '@mui/x-data-grid-pro';

const formatPercentage = (params: GridValueFormatterParams<number>) => {
  if (params.value == null) return '';
  return `${params.value} %`;
};

export { formatPercentage };
